import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import CertificationsEditTab from './Elements/CertificationsEditTab';
import CertificationSuppliersTab from './Elements/CertificationSuppliersTab';
import CertificationArchivesTab from './Elements/CertificationArchivesTab';
import getLocale from '../../i18n/getLocale';

class CertificationsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      certification_data: {},
      certification_archives: [],
      certification_groups: {},
      aircraft_models_list: [],
      certification_types_list: [],
      certifications_list: [],
      types_list: [],
      types_applicability: [],
      suppliers_list: null,
      country_list: null,
      supplier_certifications: null,
      training_certification_types_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  refreshTable(event) {
    var url = config.get('api') + '/certificado/grupos/'+this.props.match.params.id;
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certification_groups: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/certificado/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/certificados');
        if (responseJson.status === 'success') {
          self.setState({certification_data: responseJson.data});
          self.setState({types_list: responseJson.types_list});
          self.setState({types_applicability: responseJson.types_applicability});
          self.setState({certification_archives: responseJson.certification_archives});
        }
      }).then(() => {
      var url = config.get('api') + '/certificado/grupos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({certification_groups: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificado/fornecedores/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({supplier_certifications: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/paises/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({country_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/fornecedores/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({suppliers_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificados/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificado/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({training_certification_types_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificado/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({certification_types_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista modelos de aeronave */ }); /* Lista de tipos de certificado */ }); /* Lista de tipos de treinamento de certificado */}); /* Certificados lista */}); /* Fornecedores lista */}); /* Países lista */}); /* Fornecedores do certificado */}); /* Grupos do certificado */
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Certificados.EditarCertificado.titulo}</h3>
      <Link to="/certificados" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.Certificados.EditarCertificado.tabDadosDoCertificado.tituloTab}>
          <CertificationsEditTab handleAlert={this.handleAlert} refreshTable={this.refreshTable} certification_id={this.props.match.params.id} aircraft_models_list={this.state.aircraft_models_list} certification_groups={this.state.certification_groups} certification_types_list={this.state.certification_types_list} certifications_list={this.state.certifications_list} training_certification_types_list={this.state.training_certification_types_list} types_list={this.state.types_list} types_applicability={this.state.types_applicability} certification_data={this.state.certification_data} />
        </Tab>
        <Tab eventKey={2} title={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.tituloTab}>
          <CertificationSuppliersTab handleAlert={this.handleAlert} certification_id={this.props.match.params.id} suppliers_list={this.state.suppliers_list} supplier_certifications={this.state.supplier_certifications} country_list={this.state.country_list} />
        </Tab>
        <Tab eventKey={3} title={this.locale.Certificados.EditarCertificado.tabArquivoMorto.tituloTab}>
          <CertificationArchivesTab handleAlert={this.handleAlert} certification_id={this.props.match.params.id} certifications_list={this.state.certifications_list} certification_archives={this.state.certification_archives} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default CertificationsEdit;



// WEBPACK FOOTER //
// ./src/Components/Certifications/CertificationsEdit.js